import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import T from '../i18n/i18n';
import { loadingActions } from '../../redux/actions';
import { reportBug } from '../../services/resources';
import { Window, Header, HeaderTitle, ButtonBar, ButtonSide, Button, Background, Content, ReportText, Heading, Text, ReportForm, Label, TextArea, ImagesUpload, FileLabel, ReportSuccess, ReportError } from './BugReport.styles';
import Keyboard from '../../services/keyboardShortcuts';

export default ({tableId}) => {
    
    const dispatch = useDispatch();

    const [description, setDescription] = useState("");
    const [files, setFiles] = useState([]);
    const [status, setStatus] = useState('');
    
    const opened = useSelector(state => state.loadingState.showBugReport);

    const close = useCallback(() => {
        dispatch(loadingActions.showBugReport(false));
        setStatus('');
        setDescription('');
        setFiles([]);
    },[dispatch]);

    const keyCancel = (e) => {
        e.stopPropagation();
    }

    const sendReport = async () => {
        try {
            const f = [];
            for (let i=0; i<files.length; i++) {
                f.push(files[i]);
            }

            await reportBug(f, description, tableId);
            setStatus('success');
        } catch (e) {
            console.error(Object.assign(e, {component: 'BugReport', id: 'sendBugReport'}));
            setStatus('error');
        }
    }

    useEffect(() => {
        let escapeKey = () => {
            close();
            return false;
        };

        Keyboard.register({key:'ESCAPE'}, escapeKey);
        
        return () => {
            Keyboard.unregister({key:'ESCAPE'}, escapeKey);
        }
    }, [close]);

    return <>
        <Background onKeyDown={keyCancel} className={opened ? 'opened' : ''} onClick={(e) => {close()}} />
        <Window onKeyDown={keyCancel} className={opened ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value="bugreport.title"/></HeaderTitle>
            </Header>

            <Content>
                {status === 'success' ? <ReportSuccess><T value="bugreport.success" /></ReportSuccess> : null}
                {status === 'error' ? <ReportError><T value="bugreport.error" /></ReportError> : null}
                {status === '' ? <>
                    <ReportText>
                        <Heading><T value="bugreport.heading" /></Heading>
                        <Text><T value="bugreport.description" /></Text>
                        <Text><T value="bugreport.response" /></Text>
                    </ReportText>
                    <ReportForm>
                        <Label><T value="bugreport.userdescription" /></Label>
                        <TextArea value={description} onChange={(e) => {setDescription(e.target.value)}} />
                        <Label><T value="bugreport.images" /></Label>
                        <ImagesUpload onChange={(e) => setFiles(e.target.files)} name="bugreport-files" id="bugreport-files" />
                        <ButtonSide style={{marginTop:'5px'}}>
                            <Button color={"#39f"} htmlFor="bugreport-files"><T value="filemanager.upload" /></Button>
                            { files.length ? <FileLabel>
                                {files.length} <T value={"filemanager.filesList"+(files.length === 1 ? '_' : '')} /> 
                            </FileLabel> : null }
                        </ButtonSide>
                    </ReportForm>
                </> : null }
            </Content>
            
            <ButtonBar>
                <ButtonSide></ButtonSide>
                <ButtonSide>
                    {status === '' ? 
                        <Button color={"#0c0"} onClick={() => {sendReport()}}><T value="send" /></Button>
                    : null}
                    <Button color={"#999"} onClick={(e) => {close()}}><T value="cancel" /></Button>
                </ButtonSide>
            </ButtonBar>
        </Window>
    </>;

};